import axios from 'axios';

function transformArrayToObject(array) {
    const result = {};
  
    array.forEach(item => {
      result[item.name] = item.value;
    });
  
    return result;
  }
  

/**
   * Make an HTTP request using Axios.
   * @param {string} method - The HTTP method (GET, POST, etc.)
   * @param {string} endpoint - The API endpoint to call.
   * @param {Object} [body] - The request body, optional.
   * @param {Object} [headers] - The request headers, optional.
   * @param {string} [baseUrl] - Option to provide the baseUrl for this call
   * @returns {Promise} - The promise that resolves to the response of the request.
   */
export const makeRequest = async (method, endpoint, body = {}, headers = {}, baseUrl = '') => {
    try {
        const url = `${baseUrl}${endpoint}`;
        if(Array.isArray(headers)){
            headers = transformArrayToObject(headers);
        }
        const config = { method, url, headers };
        
        if (method !== 'GET' && method !== 'HEAD') {
            config.data = body;
        }

        const response = await axios(config);
        return response.data;
    } catch (error) {
        // Handle error appropriately
        console.error('Request failed:', error);
        throw error;
    }
}